import { render, staticRenderFns } from "./zhuanyun.vue?vue&type=template&id=30c0de6b&scoped=true"
import script from "./zhuanyun.vue?vue&type=script&lang=js"
export * from "./zhuanyun.vue?vue&type=script&lang=js"
import style0 from "./zhuanyun.vue?vue&type=style&index=0&id=30c0de6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c0de6b",
  null
  
)

export default component.exports